'use client';

import { IModale } from '@/types/components/modale';
import { faAndroid, faApple } from '@fortawesome/free-brands-svg-icons';
import { faClose, faQrcode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';

export const Modale: React.FC<IModale> = ({ closeModale }) => {
  const urlAppStore =
    'https://apps.apple.com/fr/app/the-club-nftouring/id6474618050';
  const urlGooglePlay =
    'https://play.google.com/store/apps/details?id=com.nftouringtheclub.android&hl=fr';

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-70 z-40" />

      <section className="fixed z-50 inset-0 text-center bg-zinc-900 border border-gray-600 rounded-lg p-4 xl:max-w-[23%] xl:max-h-[75%] xl:min-h-[75%] xl:min-w-[30%] lg:max-w-[40%] lg:max-h-[80%] md:max-w-[60%] md:max-h-[80%] sm:max-w-[60%] sm:max-h-[80%] xs:max-w-[80%] xs:max-h-[75%] mx-auto my-auto">
        <FontAwesomeIcon
          icon={faQrcode}
          className="text-red-600 text-[60px] mt-4 mx-auto"
        />
        <button
          onClick={closeModale}
          className="absolute top-2 right-2 text-gray-400"
        >
          <FontAwesomeIcon icon={faClose} className="text-white" />
        </button>
        <h2 className="mt-4 font-primaryBold text-white">
          Obtenir l&apos;application The Club
        </h2>
        <p className="mt-3 text-gray-400 font-primary">
          Téléchargement disponible ci-dessous
        </p>

        <div className="bg-black mx-auto mt-4 rounded-lg flex justify-center items-center w-full h-[45%]">
          <div className="bg-white h-[200px] w-[200px] md:h-[200px] md:w-[200px] rounded-lg overflow-hidden relative">
            <Image
              src="/images/QRcode.png"
              alt="QR code pour rejoindre l'application sur mobile"
              title="QR code pour rejoindre The Club sur mobile"
              fill
              className="object-cover p-2"
            />
          </div>
        </div>

        <div className="flex flex-col items-center text-black mt-6 space-y-4 font-primaryBold sm:text-base xs:text-xs">
          <button
            className="bg-white p-4 w-[90%] sm:w-[80%] flex items-center justify-center rounded-lg hover:bg-zinc-200"
            onClick={() =>
              window.open(urlAppStore, '_blank', 'noopener noreferrer')
            }
          >
            <FontAwesomeIcon icon={faApple} className="mr-2 size-[25px] font-primary" />
            Télécharger sur l&apos;App Store
          </button>
          <button
            className="bg-white p-4 w-[90%] sm:w-[80%] flex items-center justify-center rounded-lg hover:bg-zinc-200"
            onClick={() =>
              window.open(urlGooglePlay, '_blank', 'noopener noreferrer')
            }
          >
            <FontAwesomeIcon icon={faAndroid} className="mr-2 size-[25px] font-primary" />
            Télécharger sur Google Play
          </button>
        </div>
      </section>
    </>
  );
};
